'use client'

import { Card, Cell, Divider, InputText, Text } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/shared/ui-helpers'
import { useSession } from '@marketplace-web/shared/session'
import { useTranslate } from '@marketplace-web/shared/i18n'

enum Field {
  FullName = 'businessRepresentative.fullName',
  Birthday = 'businessRepresentative.birthday',
  Nationality = 'businessRepresentative.nationality',
  Country = 'businessRepresentative.country',
}

const BusinessRepresentative = () => {
  const translate = useTranslate('profile_settings.business_representative')
  const { user } = useSession()
  const businessAccount = user?.business_account

  if (!user || !businessAccount) return null

  return (
    <Card>
      <Cell styling={Cell.Styling.Wide}>
        <Text
          as="h4"
          width={Text.Width.Parent}
          alignment={Text.Alignment.Left}
          type={Text.Type.Subtitle}
          text={translate('title')}
        />
      </Cell>
      <Cell styling={Cell.Styling.Tight}>
        <SeparatedList separator={<Divider />}>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.FullName}
              title={translate('fields.full_name.title')}
              styling={InputText.Styling.Wide}
              value={user.real_name ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.Birthday}
              title={translate('fields.birthday.title')}
              styling={InputText.Styling.Wide}
              value={user.birthday ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.Nationality}
              title={translate('fields.nationality.title')}
              styling={InputText.Styling.Wide}
              value={businessAccount.nationality_title ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.Country}
              title={translate('fields.country.title')}
              styling={InputText.Styling.Wide}
              value={businessAccount.country_title ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
        </SeparatedList>
      </Cell>
    </Card>
  )
}

export default BusinessRepresentative
